import { IRole } from '@models';
import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import camelcaseKeys from 'camelcase-keys';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const BACKEND_URL = environment.API_URL;

@Injectable({ providedIn: 'root' })
export class UsersService {
  constructor(private http: HttpClient) {}

  getUserLocation(): any {
    // @ts-ignore
    return dbip.getVisitor();
  }

  getUserApiFromIP(): Observable<any> {
    return this.http
      .get('https://ipapi.co/json/')
      .pipe(map(response => camelcaseKeys(response, { deep: true })));
  }

  getRoles(): Observable<any> {
    return this.http.get<{ roles: IRole[] }>(BACKEND_URL + `roles`).pipe(
      map(response => {
        return response.roles.map(item => ({
          id: item?.id,
          name: item?.name,
          caption: item?.caption,
        }));
      })
    );
  }

  changeCurrency(currency: string): Observable<any> {
    return this.http.post(`${BACKEND_URL}user/currency`, { currency });
  }

  changeLanguage(language: string): Observable<any> {
    return this.http.post(`${BACKEND_URL}user/language`, { language });
  }
}
